import { ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "shields",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "category",
        "label": "Category",
    }, {
        "key": "seconds",
        "label": "Duration",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "seconds",
        "label": "Duration time in seconds",
        "type": "input",
        "format": "integer"
    }, {
        "key": "category",
        "label": "Category",
        "type": "input",
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
